
    const mBody = document.getElementsByTagName('body')[0]
    function scrollHeightCheck() {
        window.scrollY >= 100 ? mBody.classList.add('scrolled') 
                         : mBody.classList.remove('scrolled')
    }
    document.onscroll = function() { scrollHeightCheck() }
    scrollHeightCheck()


const videos = document.querySelectorAll('video[autoplay]')

var motionQuery = matchMedia('(prefers-reduced-motion: reduce)');

function handleReduceMotionChanged() {
  if(videos) {
     videos.forEach(function (video, index) {
    if (motionQuery.matches) {
        video.removeAttribute('autoplay')
        
      
    } else {
       
       
    }

    });    
   }

                    

}

motionQuery.addEventListener("change", handleReduceMotionChanged)

handleReduceMotionChanged(); // trigger once on load



var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutationRecord) {

      var bodyOverflow = document.querySelector('body').style.overflow;
       console.log(bodyOverflow);
      
      if(bodyOverflow == 'hidden'){
         console.log('open');
        setTimeout(function(){

           document.querySelector('body').insertAdjacentHTML("beforeend", '<a href="/pages/dashboard" class="spark-custom-button"><span>My Dashboard</span></a>');
        },500)
       
      }else if(bodyOverflow == 'auto'){
         console.log('closed');
         document.querySelector('.spark-custom-button').remove();
      }
    });    
});

var target = document.querySelector('body');
observer.observe(target, { attributes : true, attributeFilter : ['style'] });


//

